// import React, { useState, useContext } from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
// import s from '../styles/DeleteProject.module.css'; // создай отдельный файл стилей
// import { ProjectContext } from '../ProjectContext';

// const DeleteProjectButton = ({ projectId, onDelete }) => {
//   const [showConfirm, setShowConfirm] = useState(false);
//   const [isDeleting, setIsDeleting] = useState(false);
//   const [error, setError] = useState(null);
//   const { fetchProjects } = useContext(ProjectContext);

//   const handleDelete = async () => {
//     setIsDeleting(true);
//     setError(null);
//     try {
//       const response = await fetch(`/api/arhiv_project/${projectId}`, {
//         method: 'DELETE',
//       });

//       if (!response.ok) {
//         throw new Error(`Ошибка ${response.status}`);
//       }

//       onDelete(projectId); // уведомить родителя
//       setShowConfirm(false);
//       fetchProjects()
//     } catch (err) {
//       console.error(err);
//       setError('Не удалось удалить проект.');
//     } finally {
//       setIsDeleting(false);
//     }
//   };

//   return (
//     <>
//       <button className={s.trashButton} onClick={() => setShowConfirm(true)}>
//         <FontAwesomeIcon icon={faTrashCan} />
//       </button>

//       {showConfirm && (
//         <div className={s.modalOverlay}>
//           <div className={s.modalContent}>
//             <p>Вы уверены, что хотите удалить проект?</p>
//             {error && <p className={s.error}>{error}</p>}
//             <div className={s.actions}>
//               <button onClick={handleDelete} disabled={isDeleting}>
//                 {isDeleting ? 'Удаление...' : 'Да, удалить'}
//               </button>
//               <button onClick={() => setShowConfirm(false)}>Отмена</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default DeleteProjectButton;
import React, { useState, useContext } from 'react';
import s from '../styles/DeleteProject.module.css';
import { ProjectContext } from '../ProjectContext';

const DeleteProjectButton = ({ projectId, onDelete, onCancel }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState(null);
  const { fetchProjects } = useContext(ProjectContext);

  const handleDelete = async () => {
    setIsDeleting(true);
    setError(null);
    try {
      const response = await fetch(`/api/projects/arhiv_project/${projectId}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error(`Ошибка ${response.status}`);
      }

      onDelete(projectId); // сообщаем родителю
      fetchProjects();
    } catch (err) {
      console.error(err);
      setError('Не удалось удалить проект.');
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className={s.modalOverlay}>
      <div className={s.modalContent}>
        <p>Вы уверены, что хотите удалить проект?</p>
        {error && <p className={s.error}>{error}</p>}
        <div className={s.actions}>
          <button onClick={handleDelete} disabled={isDeleting}>
            {isDeleting ? 'Удаление...' : 'Да, удалить'}
          </button>
          <button onClick={onCancel}>Отмена</button>
        </div>
      </div>
    </div>
  );
};

export default DeleteProjectButton;
